// product-card-v2
function shokzEnsurePro2Debug() {
  if (typeof window.shokzOpenrunPro2CardDebug === "function") return;
  window.shokzOpenrunPro2CardDebug = function (source, action, payload) {
    try {
      if (!/\bshokz_debug_pro2=1\b/.test(String(window.location.search || ""))) {
        return;
      }
      console.log("[shokz_pro2]", source || "card", action, payload || "");
    } catch (e) {}
  };
}

function shokzApplySwatchVisibilityFromSizeOptions(rootEl, sourceTag) {
  if (!rootEl) return;
  shokzEnsurePro2Debug();

  const activeOptions = Array.from(
    rootEl.querySelectorAll(".other-options-content .o-item.active")
  ).map((item) => (item.getAttribute("data") || "").trim());

  const onlyStandard =
    activeOptions.length === 1 && activeOptions[0] === "Standard";
  const onlyMini = activeOptions.length === 1 && activeOptions[0] === "Mini";

  const swatches = rootEl.querySelectorAll(".product-color-swatch-wrapper .swatch");
  const rows = [];

  swatches.forEach((swatch) => {
    const swatchData = swatch.getAttribute("data") || "";
    const g = (swatch.getAttribute("data-size-group") || "").toLowerCase();
    const td = swatchData.toLowerCase();
    const id = swatch.getAttribute("data-id") || "";
    let hide = false;

    if (onlyStandard) {
      hide = g === "mini" || td.includes("mini");
    } else if (onlyMini) {
      hide = !(g === "mini" || td.includes("mini"));
    } else {
      if (activeOptions.includes("Standard") && swatchData.includes("Mini")) {
        hide = true;
      } else {
        const nonStandardOptions = activeOptions.filter((opt) => opt !== "Standard");
        if (nonStandardOptions.length === 0) {
          hide = false;
        } else {
          hide = !nonStandardOptions.every((optionValue) =>
            swatchData.includes(optionValue)
          );
        }
      }
    }
    swatch.classList.toggle("hidden", hide);
    rows.push({ id, g, hide, tip: swatchData.slice(0, 64) });
  });

  window.shokzOpenrunPro2CardDebug(sourceTag || "swatch", "apply", {
    activeOptions,
    onlyStandard,
    onlyMini,
    rowCount: rows.length,
    rows,
  });

  const visibleSwatches = rootEl.querySelectorAll(
    ".product-color-swatch-wrapper .swatch:not(.hidden)"
  );
  if (visibleSwatches.length > 0) {
    visibleSwatches.forEach((s) => s.classList.remove("active"));
    const firstVisible = visibleSwatches[0];
    firstVisible.classList.add("active");
    firstVisible.click();
  }
}

class ProductCardV2 extends HTMLElement {
  constructor() {
    super();
  }
  init() {
    this.addCompareButton = this.querySelector(".compare-select-button");
    this.productJson = JSON.parse(
      this.querySelector("[data-product-json]").textContent
    );
    this.panel = document.querySelector("product-compare-panel");
    this.remove = this.querySelector("[data-remove]");
    this.addCompareButton.classList.remove("loading");
    this.listenEvents();

    this.swatches = this.querySelectorAll(".product-color-swatch-wrapper .swatch");
    this.listenSwatches();
    this.initOpenrunSizeFilterOnCard();
  }

  initOpenrunSizeFilterOnCard() {
    const mainContent = this.querySelector(".product-card-v2 > .product-card__content");
    if (!mainContent) return;
    const sizeRoot = mainContent.querySelector(".product-card-v2-size-filter");
    if (!sizeRoot) return;

    mainContent
      .querySelectorAll(".product-card-v2-size-filter .other-options-content .o-item")
      .forEach((otherItem) => {
        otherItem.addEventListener("click", () => {
          const group = otherItem.closest(".other-options-content");
          if (!group) return;
          group.querySelectorAll(".o-item.active").forEach((activeItem) => {
            activeItem.classList.remove("active");
          });
          otherItem.classList.add("active");
          shokzApplySwatchVisibilityFromSizeOptions(mainContent, "product-card-v2");
        });
      });
    shokzApplySwatchVisibilityFromSizeOptions(mainContent, "product-card-v2-init");
  }
  listenEvents() {
    this.addCompareButton.addEventListener("click", (e) => {
      e.preventDefault();
      if (this.classList.contains("checked")) {
        this.panel.dispatchEvent(
          new CustomEvent("compare:remove", {
            detail: {
              productHandle: this.productJson.handle,
            },
          })
        );
      } else {
        this.panel.dispatchEvent(
          new CustomEvent("compare:add", {
            detail: {
              productJson: this.productJson,
              productCard: this,
            },
          })
        );
      }
      // console.log("product json", this.productJson);
    });
  }

  // 产品卡片色块切换
  listenSwatches() {
    this.swatches.forEach((swatch) => {
      swatch.addEventListener("click", () => {
        // 获取当前卡片容器
        const card = swatch.closest(".product-card-v2");

        // 清除当前卡片所有 swatch 的 active
        card?.querySelectorAll(".swatch").forEach((s) => s.classList.remove("active"));
        swatch.classList.add("active");

        // 获取当前选中的颜色信息
        const selectedColor = swatch.getAttribute("data");
        const selectedSku = swatch.getAttribute("data-sku");
        const selectedId = swatch.getAttribute("data-id");
        const available = swatch.getAttribute("data-varavailable") === "true";

        // console.log("选中颜色:", selectedColor, "SKU:", selectedSku, "可用:", available, "data-id:", selectedId);

        // 切换当前卡片的图片，使用 data-id 匹配
        const images = card?.querySelectorAll(".product-card__image .variant-img");
        images?.forEach((img) => {
          const imgId = img.getAttribute("data-id");
          img.classList.toggle("active", imgId === selectedId);
        });

        // 切换价格
        const prices = card?.querySelectorAll(".product-card__content .prices-wrapper .prices");
        prices?.forEach((price) => {
          price.classList.toggle("active", price.getAttribute("data-id") === selectedId);
        });

        // 切换变体按钮 active
        const variantButtons = card?.querySelectorAll(".variant-wrapper.quick-add__submit");
        variantButtons?.forEach((btn) => {
          const isActive = btn.getAttribute("data-id") === selectedId;
          btn.classList.toggle("active", isActive);

          // 如果这个按钮是当前选中的
          if (isActive) {
            const addBtn = btn.querySelector("button.addtocart");
            if (addBtn) {
              if (available) {
                btn.classList.remove("disable");
                addBtn.classList.remove("disable");
                addBtn.disabled = false;
              } else {
                btn.classList.add("disable");
                addBtn.classList.add("disable");
                addBtn.disabled = true;
              }
            }
          }
        });


        // 更新当前卡片 form 的 hidden input[id]
        const form = card?.querySelector('.add-to-cart-form2');
        const inputId = form?.querySelector('input[name="id"]');
        if (inputId) {
          inputId.value = selectedId;
        }
      });
    });
  }



  connectedCallback() {
    this.init();
  }
}

customElements.define("product-card-v2", ProductCardV2);

if (!customElements.get("compare-result-item")) {
  customElements.define(
    "compare-result-item",
    class extends HTMLElement {
      constructor() {
        super();
      }
      connectedCallback() {
        this.swatches = this.querySelectorAll(".swatch");
        this.initColorSwatch();
        this.listenEvents();
      }
      isMobile() {
        return window.matchMedia("(max-width: 768px)");
      }
      // 产品对比数据
      listenEvents() {
        // 点击色卡切换图片
        this.swatches.forEach((swatch) => {

          swatch.addEventListener("click", () => {
            // 1️⃣ 获取当前点击的 swatch（色块）的库存状态
            // data-varavailable 是自定义属性，标识此变体是否可用（true/false）
            const nowstatus = swatch.getAttribute("data-varavailable") === "true";

            // 2️⃣ 遍历所有 swatch，清除它们的 active 状态，只保留当前点击的为 active
            this.swatches.forEach((_swatch) => {
              if (_swatch != swatch) {
                _swatch.classList.remove("active");
              }
            });

            // 3️⃣ 给当前点击的 swatch 添加 active（若当前还没被激活）
            if (!swatch.classList.contains("active")) {
              swatch.classList.add("active");
            }

            // 4️⃣ 获取当前 swatch 对应的变体 ID（用于匹配图片、价格、按钮）
            const id = swatch.getAttribute("data-id");

            // 5️⃣ 切换产品主图 —— 移除当前 active 图片，显示与当前选中变体对应的图片
            this.querySelector(`.variant-img.active`)?.classList.remove("active");
            this.querySelector(`.variant-img[data-id="${id}"]`).classList.add("active");

            // 6️⃣ 切换价格 —— 移除当前 active 价格，显示当前变体对应的价格
            this.querySelector(`.prices.active`)?.classList.remove("active");
            this.querySelector(`.prices[data-id="${id}"]`).classList.add("active");

            // 切换“BUY NOW”按钮对应的变体（让当前选中变体的按钮 active）
            const variantButtons = this.querySelectorAll(".variant-wrapper.quick-add__submit");
            variantButtons.forEach((btn) => {
              const match = btn.getAttribute("data-id") === id; // 是否匹配当前选中变体
              // 控制 active 状态
              btn.classList.toggle("active", match);
              

              if (match) {
                const addBtn = btn.querySelector("button.addtocart");
                if (addBtn) {
                  const isDisabled = !nowstatus;
                  btn.classList.toggle("disable", isDisabled);     // 给整个 variant-wrapper 加 disable
                  addBtn.classList.toggle("disable", isDisabled); // 给按钮本身加 disable
                  addBtn.disabled = isDisabled;                   // 禁用按钮点击

                  // 修改文案
                  const textSpan = addBtn.querySelector("span");
                  if (textSpan) {
                    textSpan.textContent = nowstatus ? "Jetzt kaufen" : (window.SHOKZ_LABELS && window.SHOKZ_LABELS.soldOut ? window.SHOKZ_LABELS.soldOut : "SOLD OUT");
                  }

                  // 根据 disable 状态隐藏或显示按钮内部的 SVG
                  const svgIcon = addBtn.querySelector("svg");
                  if (svgIcon) {
                    svgIcon.style.display = isDisabled ? "none" : "inline-block";
                  }
                }
              }
            });

            // 同步更新隐藏 input 的 variant id，让加购时提交选中的变体
            const hiddenInput = this.querySelector('.add-to-cart-form2 input[name="id"]');
            if (hiddenInput) hiddenInput.value = id;
          });

        });

        this.querySelectorAll(".other-options-content .o-item").forEach((otherItem) => {
          otherItem.addEventListener("click", () => {
            // 找到当前选项所属的那一组（父容器）
            const group = otherItem.closest(".other-options-content");
            if (!group) return;

            // 清除该组内的 active
            group.querySelectorAll(".o-item.active").forEach((activeItem) => {
              activeItem.classList.remove("active");
            });

            // 设置当前点击项为 active
            otherItem.classList.add("active");

            this.initColorSwatch();
          });
        });

      }
      initColorSwatch() {
        shokzApplySwatchVisibilityFromSizeOptions(this, "compare-result-item");
      }

    }
  );
}
